import { NgModule } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { EmptyRouteComponent } from './components/empty-route/empty-route.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CoreUiModule } from '@pos-app/core-ui';
import { AppRoutingModule } from '../app-routing.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule as MatListModule } from '@angular/material/list';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [CommonModule, CoreUiModule, AppRoutingModule, MatSidenavModule, MatListModule, MatTooltipModule, MatIconModule, ReactiveFormsModule, NgSelectModule, FooterComponent, EmptyRouteComponent, NavbarComponent],
    exports: [FooterComponent, EmptyRouteComponent, NavbarComponent],
    providers: [],
})
export class CoreModule {}


